// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__4PRrc","ulParagraph":"Faq_ulParagraph__xn8Vn","loading":"Faq_loading__j-NGz"};